import { render, staticRenderFns } from "./MortgageReviewForReferralCard.vue?vue&type=template&id=03c2bf3d"
import script from "./MortgageReviewForReferralCard.vue?vue&type=script&lang=js"
export * from "./MortgageReviewForReferralCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports